import React from "react";

import useBrowser from "../../hooks/useBrowser";

import Modal from "./Modal";
import CallDocket from "../ui/CallDocket";

const CallDocketModal = ({
  call,
  open,
  onClose,
  onRefresh,
  readOnly = false,
}) => {
  const { windowHeight } = useBrowser();

  const handleClose = async (...args) => {
    if (typeof onRefresh === "function") {
      await onRefresh();
    }

    if (typeof onClose === "function") {
      onClose(...args);
    }
  };

  return (
    <Modal
      title="Call Docket"
      open={open}
      onClose={handleClose}
      height={`${windowHeight}px`}
      width="600px"
    >
      <CallDocket
        call={call}
        onRefresh={onRefresh}
        onClose={handleClose}
        readOnly={readOnly}
      />
    </Modal>
  );
};

export default CallDocketModal;
